export default {"src":"/_next/static/media/icon-phone-new.ab1f84f2.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};